<template>
  <div
    class="is-flex"
    @click="$emit('moveTo')"
  >
    <div
      class="text-white px-1 mt-4 is-flex-center p-4"
      :style="{
        backgroundColor: currentQuestionId === question.id ? $root.$data.COLORS.primary[3] : $root.$data.COLORS.gray[4],
        color: currentQuestionId === question.id ? $root.$data.COLORS.neutral[7] : $root.$data.COLORS.gray[2],
        borderRadius: '0.5em 0 0 0.5em',
        height: '50px'
      }"
    >
      {{ $route.params.section }}.{{ question.id }}
    </div>
    <div
      class="question p-6 card curved-border is-flex-grow-1"
      :style="{borderWidth: '2px', borderColor: currentQuestionId === question.id ? $root.$data.COLORS.primary[3] : 'transparent'}"
    >
      <header class="pb-5">
        <h1 class="title is-4 bold">
          {{ question.prompt }}
        </h1>
        <h2 class="subtitle is-6 has-text-grey">
          {{ question.subprompt }}
        </h2>

        <div v-if="question.links">
          <a
            v-for="link in question.links"
            :key="link.name"
            :href="$root.$data.STATIC_ROOT + link.href"
            target="_blank"
            rel="noreferrer noopener"
            style="font-size: 18px"
          >
            {{ link.name }}
          </a>
        </div>
      </header>


      <div class="mb-4">
        <b-tooltip
          :label="adminOnlyMsg"
          :active="!isEditable"
          class="width-100"
        >
          <QuestionInputText
            v-if="isText"
            :is-editable="isEditable"
            :prev-answer="question.answer"
            :admin-answer="adminAnswer"
            @answered="(answer) => $emit('answered', answer)"
          />

          <QuestionInputRadio
            v-if="isRadio"
            :choices="question.choices"
            :prev-answer="question.answer"
            @answered="(answer) => $emit('answered', answer)"
          />

          <QuestionInputCheckbox
            v-if="isCheckbox"
            :choices="question.choices"
            :prev-answer="question.answer"
            @answered="(answer) => $emit('answered', answer)"
          />

          <QuestionInputNumber
            v-if="isNumber"
            :items="question.items"
            :config="question.config"
            :prev-answer="question.answer"
            @answered="(answer) => $emit('answered', answer)"
          />

          <QuestionInputRankOrder
            v-if="isRankOrder"
            :choices="question.choices"
            :prev-answer="question.answer"
            @answered="(answer) => $emit('answered', answer)"
          />
        </b-tooltip>
      </div>


      <div class="is-flex">
        <div class="is-flex-grow-1">
          <b-button
            v-if="!isLast"
            class="heavy"
            :style="{backgroundColor: $root.$data.COLORS.primary[5], color: $root.$data.COLORS.primary[3]}"
            @click.stop="$emit('moveToNext')"
          >
            Next question
          </b-button>
        </div>
        <div
          v-if="!isFirst"
          class="is-flex is-justify-content-flex-end"
        >
          <b-button
            class="heavy"
            :style="{borderColor: 'transparent', color: $root.$data.COLORS.primary[3]}"
            @click.stop="$emit('moveToPrevious')"
          >
            Previous
          </b-button>
        </div>
      </div>
    </div>
  </div>
  <!-- </a> -->
</template>


<script>
import QuestionInputText from './QuestionInputText.vue';
import QuestionInputRadio from './QuestionInputRadio.vue';
import QuestionInputCheckbox from './QuestionInputCheckbox.vue';
import QuestionInputNumber from './QuestionInputNumber.vue';
import QuestionInputRankOrder from './QuestionInputRankOrder.vue';


export default {
  name: 'Question',
  components: {
    QuestionInputText,
    QuestionInputRadio,
    QuestionInputCheckbox,
    QuestionInputNumber,
    QuestionInputRankOrder,
  },
  props: ['question', 'section', 'currentQuestionId', 'isLast', 'context', 'adminResponses'],
  data() {
    return {
      adminOnlyMsg: 'This question can only be filled out by your organization admin',
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    isText() {
      return this.question.type === 'text';
    },
    isRadio() {
      return this.question.type === 'radio';
    },
    isCheckbox() {
      return this.question.type === 'checkbox';
    },
    isNumber() {
      return this.question.type === 'number';
    },
    isRankOrder() {
      return this.question.type === 'rankorder';
    },
    isFirst() {
      return this.question.id === 1;
    },
    isEditable() {
      return !this.question.admin_only || this.context.prospect_is_admin;
    },
    adminAnswer() {
      if (!this.adminResponses) return null;
      return this.adminResponses[this.question.slug];
    },
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
